ko.bindingHandlers.fadeVisible = {
  update: function(element, valueAccessor) {
    var afterAnimation, isCurrentlyVisible, options, shouldShow, value;
    value = ko.unwrap(valueAccessor()) || false;
    shouldShow = false;
    options = {
      duration: 500
    };
    isCurrentlyVisible = element.style.display !== 'none';
    afterAnimation = valueAccessor().afterAnimation;
    if (typeof value === 'object') {
      if (value.visible) {
        shouldShow = ko.unwrap(value.visible);
      } else {
        throw new Error('You need to have a visible value... ');
      }
      options.duration = value.duration || options.duration;
      options = $.extend(options, value.options || {});
    } else {
      shouldShow = value;
    }
    if (shouldShow && !isCurrentlyVisible) {
      $(element).stop().fadeIn(options, function() {
        if (typeof afterAnimation === 'function') {
          afterAnimation.call();
        }
      });
    } else if (!shouldShow && isCurrentlyVisible) {
      if (value.fadeOut === void 0 || value.fadeOut) {
        $(element).stop().fadeOut(options, function() {
          if (typeof afterAnimation === 'function') {
            afterAnimation.call();
          }
        });
      } else {
        element.style.display = 'none';
      }
    }
  }
};
